import { privatePagesList, publicPagesList } from '../constants/pages';

export function getMenuItem(label, key, permissions, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
    permissions: permissions || [],
  };
}

export const menuList = [
//  getMenuItem('Montebravo', 'montebravo', null, [
//    getMenuItem(pagesList.aberturaMercadoMontebravo.menuName, pagesList.aberturaMercadoMontebravo.slug),
//    getMenuItem(pagesList.fechamentoMercadoMontebravo.menuName, pagesList.fechamentoMercadoMontebravo.slug),
//  ]),
  getMenuItem(privatePagesList.send.menuName, privatePagesList.send.slug, ['ROLE_ADMIN', 'MANAGE_SEND']),
  getMenuItem(privatePagesList.tyra.menuName, privatePagesList.tyra.slug, ['ROLE_ADMIN', 'MANAGE_TYRA']),
  getMenuItem(privatePagesList.marketStory.menuName, privatePagesList.marketStory.slug, ['ROLE_ADMIN', 'MANAGE_MARKET_STORY']),
  getMenuItem(privatePagesList.expense.menuName, privatePagesList.expense.slug, ['ROLE_ADMIN', 'MANAGE_EXPENSES']),
  getMenuItem(privatePagesList.panel.menuName, privatePagesList.panel.slug, ['ROLE_ADMIN']),
  getMenuItem(privatePagesList.report.menuName, privatePagesList.report.slug, ['ROLE_ADMIN']),
//  getMenuItem(privatePagesList.user.menuName, privatePagesList.user.slug),
  getMenuItem('Usuários', 'usuarios/listar', ['ROLE_ADMIN']),
];
